import styled from '@emotion/styled';
import COLORS from '$variables/colors';
import { typography, spacing, breakpoints } from '$variables/theme';

export const Wrapper = styled.div`
  background-color: ${COLORS.white};
  border-radius: 4px;
  padding: ${spacing.medium};
  margin-bottom: ${spacing.xxLarge};
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: ${typography.fontWeightSemiBold};
  line-height: 24px;
`;

export const Decorations = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${spacing.small};

  @media (min-width: ${breakpoints.mediumStart}) {
    align-items: center;
  }
`;

export const RightDecorations = styled.div`
  > *:not(:last-child) {
    margin-bottom: ${spacing.xSmall};

    @media (min-width: ${breakpoints.mediumStart}) {
      margin-right: ${spacing.xSmall};
    }
  }
`;

export const LeftDecorations = styled.div`
  display: flex;

  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${breakpoints.mediumStart}) {
    flex-direction: row;
    align-items: center;
  }

  & > * {
    margin-bottom: ${spacing.xSmall};

    @media (min-width: ${breakpoints.mediumStart}) {
      margin-right: ${spacing.xSmall};
    }
  }
`;

export const GradeType = styled.div`
  line-height: 20px;
  font-size: 12px;
  margin-top: ${spacing.xSmall};
`;

export const GradeTypeValue = styled.span`
  font-weight: ${typography.fontWeightSemiBold};
  margin-left: 2px;
`;
